import Uuid from 'uuid'
import cloneDeep from 'lodash/cloneDeep'

import {
  getAttrs,
  parseAttributes
} from 'utils/index'

import {
  CREATE_EDITOR_STATE,
  DESTROY_EDITOR_STATE,
  ADD_COMPONENT_TO_PAGE,
  REMOVE_COMPONENT_FROM_PAGE,
  MOVE_PAGE_COMPONENT,
  OPEN_BROWSER,
  CLOSE_BROWSER,
  SELECT_PAGE_COMPONENT,
  UNSELECT_PAGE_COMPONENT,
  UPDATE_PAGE_COMPONENT_ATTRIBUTE,
  SAVE_PAGE_CHANGES_REQUEST,
  SAVE_PAGE_CHANGES_DATA_MERGE,
  SAVE_PAGE_CHANGES_SUCCESS,
  SAVE_PAGE_CHANGES_COMPLETE
} from 'actions/editor'

const createUntouchedState = (state) => {
  return cloneDeep({
    hasUnsavedChanges: false,

    isBrowserOpen: false,
    isEditorOpen: false,

    pageComponents: state.pageComponents,
    pageComponent: null,

    insertAtIndex: null
  })
}

export default (state, action) => {
  switch (action.type) {
    case CREATE_EDITOR_STATE:
      return {
        ...state,
        untouchedState: createUntouchedState(state)
      }

    case DESTROY_EDITOR_STATE:
      return { ...state, ...state.untouchedState }

    case ADD_COMPONENT_TO_PAGE:
      return (() => {
        const pageComponents = [...state.pageComponents]

        pageComponents.splice(state.insertAtIndex, 0, {
          _cid: Uuid(),
          component: action.component,
          attributes: parseAttributes([]),
          attrs: getAttrs([], { parseAttributes: true })
        })

        return {
          ...state,
          hasUnsavedChanges: true,
          isBrowserOpen: false,
          insertAtIndex: null,
          pageComponents
        }
      })()

    case REMOVE_COMPONENT_FROM_PAGE:
      return {
        ...state,
        hasUnsavedChanges: true,
        pageComponents: state.pageComponents.filter(pageComponent =>
          pageComponent._cid !== action.pageComponentClientId
        )
      }

    case MOVE_PAGE_COMPONENT:
      return (() => {
        const pageComponents = [...state.pageComponents]

        const currentIndex = pageComponents
          .map(({ _cid }) => _cid)
          .indexOf(action.pageComponentClientId)

        const newIndex = Math.max(0, Math.min(currentIndex + action.position, pageComponents.length - 1))

        const tmp = pageComponents[newIndex]
        pageComponents[newIndex] = pageComponents[currentIndex]
        pageComponents[currentIndex] = tmp

        return {
          ...state,
          hasUnsavedChanges: true,
          pageComponents
        }
      })()

    case OPEN_BROWSER:
      return {
        ...state,
        isBrowserOpen: true,
        insertAtIndex: action.insertAtIndex
      }

    case CLOSE_BROWSER:
      return {
        ...state,
        isBrowserOpen: false,
        insertAtIndex: null
      }

    case SELECT_PAGE_COMPONENT:
      return {
        ...state,
        isEditorOpen: true,
        pageComponent: action.pageComponent
      }

    case UNSELECT_PAGE_COMPONENT:
      return {
        ...state,
        isEditorOpen: false,
        pageComponent: null
      }

    case UPDATE_PAGE_COMPONENT_ATTRIBUTE:
      return (() => {
        const pageComponents = [...state.pageComponents]
        const attributes = [...state.pageComponent.attributes]

        const attributeIndex = attributes
          .map(i => i.key)
          .indexOf(action.attribute.key)

        if (attributeIndex > -1) {
          attributes[attributeIndex] = action.attribute
        } else {
          attributes.push(action.attribute)
        }

        const pageComponent = {
          ...state.pageComponent,
          attributes,
          attrs: getAttrs(attributes)
        }

        const pageComponentIndex = pageComponents
          .map(i => i._cid)
          .indexOf(state.pageComponent._cid)

        pageComponents[pageComponentIndex] = pageComponent

        return {
          ...state,
          hasUnsavedChanges: true,
          pageComponents,
          pageComponent
        }
      })()

    case SAVE_PAGE_CHANGES_REQUEST:
      return { ...state, isSaving: true }

    case SAVE_PAGE_CHANGES_DATA_MERGE:
      return (() => {
        // Add real ids to page components
        const pageComponents = [...state.pageComponents].map((pageComponent, index) => {
          const updatedPageComponent = action.page.components[index]

          return {
            ...pageComponent,
            _id: updatedPageComponent._id
          }
        })

        let pageComponent = null

        if (state.pageComponent) {
          const pageComponentIndex = pageComponents
            .map(({ _cid }) => _cid)
            .indexOf(state.pageComponent._cid)

          pageComponent = pageComponents[pageComponentIndex]
        }

        const newState = {
          ...state,
          hasUnsavedChanges: false,
          pageComponents,
          pageComponent
        }

        return {
          ...newState,
          untouchedState: createUntouchedState(newState)
        }
      })()

    case SAVE_PAGE_CHANGES_SUCCESS:
      return { ...state, isSaving: false, isSavingSuccessful: true }

    case SAVE_PAGE_CHANGES_COMPLETE:
      return { ...state, isSavingSuccessful: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/editor.js